import Dialog from 'primevue/dialog'

/**
 * Comportement commun de tous les dialogues : le Dialog de PrimeVue, et la ConfirmDialog qui s'en sert. PrimeVue n'a
 * pas de réglage global pour ça et chaque dialogue l'importe lui-même : on ajuste le composant une fois, au démarrage.
 * - Un clic sur le masque ferme le dialogue, sauf s'il n'est pas refermable (`closable` faux, pendant un enregistrement).
 * - À l'ouverture, le focus va au dialogue lui-même, plus au bouton de fermeture que PrimeVue entourait d'un anneau :
 *   un lecteur d'écran l'annonce, et Tab part de son premier champ. Un élément `autofocus` garde la priorité (les
 *   boutons de la ConfirmDialog).
 * Le séparateur entre en-tête et contenu est dans base.scss.
 */

interface InstanceDialogue {
  container: HTMLElement | null
  mask: HTMLElement | null
  maskMouseDownTarget: EventTarget | null
  closable: boolean
  dismissableMask: boolean
  modal: boolean
  close(): void
}

interface OptionsDialogue {
  extends: { props: { dismissableMask: { default: boolean } } }
  methods: {
    focus(this: InstanceDialogue): void
    onMaskMouseUp(this: InstanceDialogue): void
  }
}

const options = Dialog as unknown as OptionsDialogue

options.extends.props.dismissableMask.default = true

const focusDePrimeVue = options.methods.focus
options.methods.focus = function (this: InstanceDialogue): void {
  if (!this.container) return
  if (this.container.querySelector('[autofocus]')) {
    focusDePrimeVue.call(this)
    return
  }
  this.container.setAttribute('tabindex', '-1')
  this.container.focus({ preventScroll: true })
}

options.methods.onMaskMouseUp = function (this: InstanceDialogue): void {
  if (this.closable && this.dismissableMask && this.modal && this.mask === this.maskMouseDownTarget) this.close()
}
